<input #input type="text" [placeholder]="placeholder" class="border-0 m-0 p-0 w-100 h-100" [(ngModel)]="model" (focus)="focus(true)" (focusout)="focus(false)">

<ng-content></ng-content>